import { render } from "./CustomQuestionnaireComponent.vue?vue&type=template&id=40def827&scoped=true"
import script from "./CustomQuestionnaireComponent.vue?vue&type=script&lang=js"
export * from "./CustomQuestionnaireComponent.vue?vue&type=script&lang=js"

import "./CustomQuestionnaireComponent.vue?vue&type=style&index=0&id=40def827&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-40def827"

export default script